import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SiteVisitReport, Weather } from "../../Types/SiteVisitReport/SiteVisitReportType";
import { fetchSiteVisitReports, fetchWeather } from "../../Thunks/SiteVisitReportThunks";

interface SiteVisitSliceState {
    siteVisitReportLoading: boolean;
    siteVisitReports: SiteVisitReport[];
    siteVisitReportError: string | null;

    weatherLoading: boolean;
    weathers: Weather[];
    weatherError: string | null;
}

// set inital values
const initialState: SiteVisitSliceState = {
    siteVisitReportLoading: false,
    siteVisitReports: [],
    siteVisitReportError: '',

    weatherLoading: false,
    weathers: [],
    weatherError: '',
}

const siteVisitReportSlice = createSlice({
    name: 'siteVisitReport',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            // Site visit report data
            .addCase(fetchSiteVisitReports.rejected, (state, action) => {
                state.siteVisitReportLoading = false;
                state.siteVisitReportError = action.error.message!;
            })
            .addCase(fetchSiteVisitReports.pending, state => {
                state.siteVisitReportLoading = true;
                state.siteVisitReportError = null;
            })
            .addCase(fetchSiteVisitReports.fulfilled, (state, action: PayloadAction<SiteVisitReport[]>) => {
                state.siteVisitReports = [];
                state.siteVisitReportLoading = false;
                state.siteVisitReports = action.payload;
            })

            // Weather data
            .addCase(fetchWeather.rejected, (state, action) => {
                state.weatherLoading = false;
                state.weatherError = action.error.message!;
            })
            .addCase(fetchWeather.pending, state => {
                state.weatherLoading = true;
                state.weatherError = null;
            })
            .addCase(fetchWeather.fulfilled, (state, action: PayloadAction<Weather[]>) => {
                state.weathers = [];
                state.weatherLoading = false;
                state.weathers = action.payload;
            })
    }
})

export default siteVisitReportSlice.reducer
